import { prefixObjectValues } from '../../utils';

const PREFIX = 'employer-provider-associations';

const list = {
  inviteBtn: 'invite-btn',
  associationCard: 'association-card',
  enterVaultBtn: 'enter-vault-btn',
  disassociateBtn: 'disassociate-btn',
  removeBtn: 'remove-btn',
  historyRow: 'history-row',
  historyEmptyState: 'history-empty-state',
  historyError: 'history-error',
  historyRetryBtn: 'history-retry-btn',
  historyManagedPill: 'history-managed-pill',
  invitationRow: 'invitation-row',
  resendBtn: 'resend-btn',
  revokeBtn: 'revoke-btn',
  emptyState: 'empty-state',
  searchInput: 'search-input',
  addBtn: 'add-btn',
  employerManagedPill: 'employer-managed-pill',
  sendManagedInviteBtn: 'send-managed-invite-btn',
};

const tabs = {
  associatedProvidersTab: 'associated-providers-tab',
  invitationsTab: 'invitations-tab',
  previousProvidersTab: 'previous-providers-tab',
};

const inviteModal = {
  modal: 'modal',
  emailInput: 'email-input',
  sendBtn: 'send-btn',
  cancelBtn: 'cancel-btn',
  errorMsg: 'error-msg',
  pendingExistsMsg: 'pending-exists-msg',
  resendPendingBtn: 'resend-pending-btn',
  cancelPendingBtn: 'cancel-pending-btn',
  npiInput: 'npi-input',
  npiErrorMsg: 'npi-error-msg',
  addInsteadLink: 'add-instead-link',
};

const addModal = {
  modal: 'add-modal',
  prefixInput: 'add-prefix-input',
  firstNameInput: 'add-first-name-input',
  lastNameInput: 'add-last-name-input',
  categorySelect: 'add-category-select',
  typeSelect: 'add-type-select',
  npiInput: 'add-npi-input',
  npiErrorMsg: 'add-npi-error-msg',
  emailInput: 'add-email-input',
  sendInvitationToggle: 'add-send-invitation-toggle',
  submitBtn: 'add-submit-btn',
  cancelBtn: 'add-cancel-btn',
  errorMsg: 'add-error-msg',
  npiHandoffMsg: 'add-npi-handoff-msg',
  npiAmbiguousMsg: 'add-npi-ambiguous-msg',
  npiManagedMsg: 'add-npi-managed-msg',
  conflictMsg: 'add-conflict-msg',
  emailHelper: 'add-email-helper',
  handoffConfirmBtn: 'add-handoff-confirm-btn',
};

const managedInviteModal = {
  modal: 'managed-invite-modal',
  emailInput: 'managed-invite-email-input',
  sendBtn: 'managed-invite-send-btn',
  cancelBtn: 'managed-invite-cancel-btn',
  errorMsg: 'managed-invite-error-msg',
  hasAccountMsg: 'managed-invite-has-account-msg',
  normalInviteBtn: 'managed-invite-normal-invite-btn',
};

const toast = {
  created: 'added-toast',
  emailFailed: 'added-email-failed-toast',
  enterVaultBtn: 'added-toast-enter-vault-btn',
  resendInviteBtn: 'added-toast-resend-invite-btn',
};

export default {
  list: prefixObjectValues(list, PREFIX),
  tabs: prefixObjectValues(tabs, PREFIX),
  inviteModal: prefixObjectValues(inviteModal, PREFIX),
  addModal: prefixObjectValues(addModal, PREFIX),
  managedInviteModal: prefixObjectValues(managedInviteModal, PREFIX),
  toast: prefixObjectValues(toast, PREFIX),
};
